import { apiQuery } from '../';

export const authApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      generateOtp: builder.mutation({
        query: (payload) => {
          const { email } = payload;
          return {
            url: '/auth/otp',
            method: 'post',
            data: {
              auth: {
                email,
              },
            },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useGenerateOtpMutation } = authApi;
